import React from "react";

const FormsIcon= () => {
  return (
   <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.83594 13.756H9.17066" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.5909 12.9741L13.0272 14.5378L12.0898 13.5996" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="2.5" y="2.50122" width="15.0062" height="15.0062" rx="4" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.5054 10.838H5.83594" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.08872 7.91999V5.41895" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.33698 6.66953H5.83594" stroke="#4A505C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>       
    );
};
export default FormsIcon;